import { Injectable } from "@angular/core";
import { Dataservice } from "./dataservice";
import { BaseResponse } from "../models/baseresponse";

@Injectable({
    providedIn: "root",
})
export class OnBoardApiService {
    constructor(
        private dataService: Dataservice,
    ) { }

    addKycForm(data: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.dataService.putRequest("api/v1/users/media/kyc_form", data).then(
                (response: BaseResponse<any>) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    addMedia(data: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.dataService.postRequest("api/v1/users/media/convert", data).then(
                (response: BaseResponse<any>) => {
                    console.log(response);
                    
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject(response.message);
                    }
                },
                (error) => {
                    reject(JSON.stringify(error));
                }
            );
        });
    }
    

}
